import axios from "axios";
import { getCookie } from "../helpers/common";

import { toast } from "react-toastify";
import { getEnv } from "helpers/environment";

const makeRequest = async (data) => {
  const accessToken = getCookie("accessToken");

  try {
    const response = await axios({
      method: "post",
      // url: "http://localhost:3002/graphql",
      url: getEnv("AUTH0_GATEWAY"),
      maxBodyLength: Infinity,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Apollo-Require-Preflight": true,
        Authorization: "Bearer " + accessToken,
        withCredentials: true
      }
    });
    return response?.data?.data;
  } catch (error) {
    if (error.response) {
      toast.error("Oops! Something went wrong on our end. We're working to fix it.");
    }
    return { error: error.message };
  }
};
const insertQuery = async (data) => {
  const response = await makeRequest(data);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

const updateQuery = async (data) => {
  const response = await makeRequest(data);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

const getQuery = async (data) => {
  const response = await makeRequest(data);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};
const deleteQuery = async (data) => {
  const response = await makeRequest(data);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

export { insertQuery, updateQuery, getQuery, deleteQuery };
